import { ReactComponent as LogoSvg } from "./assets/logo.svg";
import React from "react";

const Logo = (): JSX.Element => <LogoSvg style={{ cursor: "pointer" }} />;

export default Logo;
